import { Box, Divider, Typography } from '@mui/material'
import { ArrowLeft } from 'lucide-react'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { TState } from 'redux/config/root-types'
import { Shared } from 'ui/shared'
import { theme } from 'utils/conf/theme'

type Props = {
  onPressCancel: () => void
}

export const Header: FC<Props> = (props) => {
  const navigate = useNavigate()

  const booking = useSelector((state: TState) => state.bookings.currentBooking)

  const { id } = useParams()

  const onClickBack = () => {
    navigate(-1)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: '1rem',
          gap: '2.5rem',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', gap: '1rem' }}>
          <Box
            onClick={onClickBack}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '2.5rem',
              height: '2.5rem',
              cursor: 'pointer',
            }}
          >
            <ArrowLeft size={'1.25rem'} color={theme.palette.primary.main} />
          </Box>

          <Typography variant="h2" sx={{ color: '#030712' }}>
            Booking Id {id}
          </Typography>
        </Box>
        {booking && booking.booking.source === 'crm' && !booking.booking.isFutureBookingCancelled && (
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Shared.Button
              title={'Cancel booking'}
              onClick={props.onPressCancel}
              disabled={booking && booking.booking.source === 'crm' ? false : true}
            />
          </Box>
        )}
      </Box>

      <Divider sx={{ marginLeft: -16, marginRight: -16 }} />
    </>
  )
}
